const primaryNav = [
  {
    label: 'Explore',
    url: '/explore/',
  },
  {
    label: 'Must Reads',
    url: '/explore/must-reads',
  },
  {
    label: 'Best of 2019',
    url: '/explore/best-articles-2019'
  },
  {
    label: 'Trending',
    url: '/explore/trending',
  },
  {
    label: 'Tech',
    url: '/explore/technology',
  },
  {
    label: 'Finance',
    url: '/explore/finance',
  },
  {
    label: 'Health',
    url: '/explore/health',
  },
  {
    label: 'Travel',
    url: '/explore/travel',
  }
];

export const subNav = [
  ...primaryNav,
  {
    label: 'Newsletters',
    url: '/explore/pocket-hits',
  }
];

export const myList = {
  label: 'My List',
  url: '/'
};

export default primaryNav;
